import { DataCard, Stack } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import { strings } from "../../localization";
import { cpfPrivacyMask, formatAmount } from "../../utils/formatters";
import type { ITextListItemProps } from "../TextListItem";
import { TextSectionList } from "../TextSectionList";

interface IProps {
	anticipationValue: number;
	anticipationYears: number;
	transferType: string;
	pixKeyType?: string;
	pixKey?: string;
	institution?: string;
	agency: string;
	account: string;
	cpf: string;
	bank?: string;
}

export const WithdrawResume: React.FC<IProps> = observer((props) => {
	const {
		anticipationValue,
		anticipationYears,
		transferType,
		pixKeyType,
		pixKey,
		// institution,
		agency,
		account,
		cpf,
		bank,
	} = props;
	const { sectinons, labels, anticipationYears: anticipationYearsLabel } = strings.components.withdrawResume;

	const renderSectionReceive = (): ITextListItemProps[] => {
		switch (transferType) {
			case "Pix": {
				return [
					{ name: labels.transferType, description: transferType },
					{ name: labels.pixKeyType, description: pixKeyType || "" },
					{ name: labels.pixKey, description: pixKey || "" },
					// { name: labels.institution, description: institution || "" },
					{ name: labels.cpf, description: cpfPrivacyMask(cpf) },
				];
			}
			case "TED": {
				return [
					{ name: labels.transferType, description: transferType },
					{ name: labels.bank, description: bank || "" },
					{ name: labels.agency, description: agency },
					{ name: labels.account, description: account },
					{ name: labels.cpf, description: cpfPrivacyMask(cpf) },
				];
			}
			default:
				return [];
		}
	};

	return (
		<DataCard
			extra={
				<Stack space={16}>
					<TextSectionList
						sectionTitle={sectinons[0]}
						sectionItem={[
							{ name: labels.anticipationValue, description: `${formatAmount(anticipationValue)}` },
							{ name: labels.anticipationYears, description: anticipationYearsLabel(anticipationYears) },
						]}
					/>
					<TextSectionList sectionTitle={sectinons[1]} sectionItem={renderSectionReceive()} isLast data-cs-mask />
				</Stack>
			}
		/>
	);
});
